import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawPromotion {
  freeShipping: {
    show: boolean
  }
}

export default class Promotion extends AbstractValue<RawPromotion> {
  get freeShipping(): FreeShipping {
    return new FreeShipping(this.raw.freeShipping)
  }
}

export interface RawFreeShipping {
  show: boolean
}

class FreeShipping  extends AbstractValue<RawFreeShipping> {
  get show(): boolean {
    return this.raw.show
  }
}
